import FooterSection from "assets/Footer";
import Banner from "../components/dashboardComponents/Banner";
import Catelouge from "../components/dashboardComponents/catelouge";
import FlashSale from "components/dashboardComponents/flashSale";
import WhyUs from "components/dashboardComponents/whyUs";
import TopCategories from "components/dashboardComponents/topCategories";
import NewProducts from "components/dashboardComponents/newProducts";
import TrendingProducts from "components/dashboardComponents/trendingProducts";
import SubCatalougeGroupByCatalouge from "components/dashboardComponents/SubCatalougeGroupByCatalouge";
import YoutubePreview from "components/dashboardComponents/youtubePreview";
import FreeDeliveryProducts from "components/dashboardComponents/FreeDeliveryProducts";
import ScrollToTopButton from "components/ScrollToTopButton";
import { useSettings } from "context/SettingsContext";
import GearGadget from "components/dashboardComponents/gear&gadget";
import AppleGadgetCatalogue from "components/dashboardComponents/appleGadgetCatalogue";
import AppleGadget from "components/dashboardComponents/appleGadget";

const Dashboard = () => {
  const { theme } = useSettings();
  const isDark = theme === "dark";
  return (
    <div
      className={`${isDark ? "bg-gray-100" : "bg-[#F9F9F7]"}  relative select-none min-h-screen`}
    >
      {/* <Navbar /> */}
      <Banner />
      <Catelouge />
      {/*<AppleGadgetCatalogue />*/}
      <FlashSale />
      <FreeDeliveryProducts />
      {/*<GearGadget />*/}
      {/*<AppleGadget />*/}
      <TrendingProducts />
      <NewProducts />
      <SubCatalougeGroupByCatalouge />
      <TopCategories />
      <YoutubePreview />
      {/*<WhyUs />*/}
      <FooterSection />
      <ScrollToTopButton />
    </div>
  );
};

export default Dashboard;
